__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mattermost-webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hello-pangea/dnd", "18.0.1", () => (Promise.all([__webpack_require__.e(4991), __webpack_require__.e(5292), __webpack_require__.e(2720), __webpack_require__.e(8831), __webpack_require__.e(3500)]).then(() => (() => (__webpack_require__(94991))))));
			register("@mattermost/client", "12.0.0", () => (Promise.all([__webpack_require__.e(8590), __webpack_require__.e(1977)]).then(() => (() => (__webpack_require__(51977))))));
			register("history", "4.10.1", () => (__webpack_require__.e(6936).then(() => (() => (__webpack_require__(36936))))));
			register("luxon", "3.6.1", () => (__webpack_require__.e(5056).then(() => (() => (__webpack_require__(22675))))));
			register("react-bootstrap", "github:mattermost/react-bootstrap#d693ec8082954f0e6d3e826ca6161979b29001cd", () => (Promise.all([__webpack_require__.e(4645), __webpack_require__.e(1075), __webpack_require__.e(5292), __webpack_require__.e(2720), __webpack_require__.e(8644)]).then(() => (() => (__webpack_require__(21075))))));
			register("react-dom", "19.2.8", () => (Promise.all([__webpack_require__.e(5292), __webpack_require__.e(7346)]).then(() => (() => (__webpack_require__(7346))))));
			register("react-intl", "*", () => (Promise.all([__webpack_require__.e(4806), __webpack_require__.e(5292)]).then(() => (() => (__webpack_require__(54806))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(971), __webpack_require__.e(5292)]).then(() => (() => (__webpack_require__(70971))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(9709), __webpack_require__.e(5292), __webpack_require__.e(5118)]).then(() => (() => (__webpack_require__(39709))))));
			register("react", "19.2.8", () => (__webpack_require__.e(7335).then(() => (() => (__webpack_require__(97335))))));
			register("styled-components", "5.3.7", () => (Promise.all([__webpack_require__.e(5884), __webpack_require__.e(5292), __webpack_require__.e(1649)]).then(() => (() => (__webpack_require__(55884))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};